import { render, staticRenderFns } from "./PreMatchList.vue?vue&type=template&id=5106ec5c&scoped=true"
import script from "./PreMatchList.vue?vue&type=script&lang=js"
export * from "./PreMatchList.vue?vue&type=script&lang=js"
import style0 from "./PreMatchList.vue?vue&type=style&index=0&id=5106ec5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5106ec5c",
  null
  
)

export default component.exports